import { gql } from '@apollo/client';

export const fetchOrdersForTransactionAccountInPPC = gql`
  query fetchOrdersByTransactionAccountIdInPPC(
    $transactionAccountId: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
    $fetchIsExternallyBilled: Boolean = false
  ) {
    transactionAccount(id: $transactionAccountId) {
      id
      availableInvoiceGroups {
        nodes {
          id
          shipToPriceEligibility
          shipToParty {
            id
            name
            addressLine1
            addressLine2
            city
            state
            country
            postcode
            taxId
          }
        }
      }
      orders(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          orderNumber
          billingContactEmail
          created
          contextSubject
          contextSubjectId
          billTo {
            billToCompanyName
            billToAccountId
            billToCity
            billToAddress1
            billToAddress2
            billToCountry
            billToState
            billToPostalCode
          }
          shipTo {
            shipToCompanyName
            shipToAccountId
            shipToCity
            shipToAddress1
            shipToAddress2
            shipToCountry
            shipToState
            shipToPostalCode
          }
          sourceSystem
          purchaseOrderNumber
          metadata {
            supportTicketNumber
          }
          metadataObj {
            supportTicketNumber
            handNote
            termsOfTransfer
            reasonCode
            newBillingAdmin
            currentBillingAdmin
            contractId @include(if: $fetchIsExternallyBilled)
            contractType @include(if: $fetchIsExternallyBilled)
          }
          billingGroup {
            billingGroupId
          }
          orderLineItems {
            nodes {
              lineItemId
              quantity
              type
              skipTrial
              status
              nextBillingAnchorTimestamp
              familyContainerId
              promotions {
                id
                title
                status
                type
                promotionCode
                benefits {
                  subBenefitType
                  value
                  iterations
                  duration
                  benefitType
                }
                promotionWindow {
                  endTime
                  startTime
                }
                eligibilityRules {
                  currency
                }
              }
              offering {
                id
                name
              }
              pricingPlan {
                id
                type
                billingFrequency
              }
              orderTransitionType
              salesTransitionType
              edition
              entitlementId
              entitlementNumber
              isSandbox
              isAddOn
              isApp
              parentEntitlementId
              productName
              productId
              cloudSiteHostname
              logoId
              orderLineItemsPurchaseMetadata {
                fieldName
                fieldValue
              }
              orderLineItemsAccountModification {
                accountModificationTransactionAccountId
                accountModificationInvoiceGroupId
              }
              quoteLineItemDetailsReference {
                quoteId
                quoteLineItemId
              }
              metadata {
                legacyInvoiceId
              }
              isExternallyBilled
              orderLineBillingBehaviourObject {
                startDate
                type
              }
            }
          }
        }
      }
    }
  }
`;
